import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions } from '../../../widgets/models/modal-options';
import { ModalWrapperComponent } from '../../../widgets';
import { IsgPanelContent } from '../../../widgets/accordion/accordion.component';

@Component({
  selector: 'app-search-save-popup',
  standalone: true,
  imports: [ModalWrapperComponent, IsgPanelContent],
  templateUrl: './save-confirmation-popup.component.html',
  styleUrls: ['./save-confirmation-popup.component.scss']
})
export class SaveConfirmationPopupComponent implements OnInit {
  @Input() options: ModalOptions = new ModalOptions();
  @Input() params: any[] = [];
  saveName: string = "";
  msg: string = "";
  isValid: boolean = true;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.msg = 'Changes to this page are not saved and will be disregarded, are you sure you want to continue?';
  }

  onSave(event: any) {
    this.activeModal.close(this.saveName);
  }

  onCancel(event: any) {
    this.activeModal.dismiss(event);
  }

}
